<template>
    <div class="yourCards">
        <h3>{{'components/settings/your-cards.title' | trans}} <span>({{this.cards.length}})</span></h3>
        <div class="cardsWrap">
            <transition name="fade">
                <div v-if="cardActivityLoading" class="loadingOverlay"></div>
            </transition>


            <CreditCard
                v-for="card in cards"
                :key="card.id"
                v-bind="card"

                v-on:setCardActivityLoading="(newValue) => { cardActivityLoading = newValue }"
            />
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    import CreditCard from './CreditCard';

    export default {
        data() {
            return {
                cardActivityLoading : false,
            }
        },
        computed: {
            ...mapState(['user']),
            cards: function () {
                let cards = [];

                if(!this.user || this.user.cards == undefined){
                    return cards;
                }

                for (let card of this.user.cards) {
                    cards.push({
                        cardId: card.cardId,
                        paymentMethodId: card.paymentMethodId,
                        type: card.type,
                        number: card.pan,
                        status: card.status,
                        forFuturePayments: card.status == 'valid',
                        address: {...card.address, fullAddress: this.getFullAddress(card.address)}
                    });
                }
                return cards;
            }
        },
        components: {
            CreditCard,
        },
        methods: {
            getFullAddress(address){
                let data = [];
                data.push(address.housenumber);
                data.push(address.street);
                data.push(address.city);
                data.push(address.state);
                data.push(address.country);
                data.push(address.postalcode);

                return data.filter(function(item){
                    return item ? true : false;
                }).join(', ');
            }
        },
        mounted() {

        },
    }
</script>
